import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ControlContainer, Validators } from '@angular/forms';

@Component({
	selector: 'app-label',
	templateUrl: 'label.component.html',
})
export class LabelComponent implements OnInit, OnChanges {
	@Input() controlName: string;
	showAsterisk = false;

	validatorsRequired = [Validators.required];
	errorsRequired = ['required', 'requireatleastone'];

	constructor(private controlContainer: ControlContainer) {}

	get formControl() {
		return this.controlContainer.control?.get(this.controlName);
	}

	ngOnInit() {
		this.switchAsterisk();

		this.formControl?.statusChanges.subscribe(() => {
			this.switchAsterisk();
		});
	}

	ngOnChanges() {
		this.switchAsterisk();
	}

	private switchAsterisk() {
		if (this.validateRequired()) {
			this.showAsterisk = true;
		} else {
			this.showAsterisk = false;
		}
	}

	private validateRequired() {
		return (
			this.validatorsRequired.some((validator) => this.formControl?.hasValidator(validator)) ||
			this.errorsRequired.some((error) => this.formControl?.hasError(error))
		);
	}
}
